import QuoteHighlight from './components/QuoteHighlight';
export default QuoteHighlight;